var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"action-button",class:{ 'action-button__primary': _vm.isPrimary },attrs:{"tile":"","elevation":"0","outlined":_vm.outlined,"color":_vm.buttonColor,"disabled":_vm.disabled,"loading":_vm.loading},on:{"click":_vm.doClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }